<template>
  <div>
    <div class="header">
      <div class="content">
        <div class="logo" @click="goHome" style="cursor: pointer;">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <div class="nav">
          <div class="nav_center">
            <div class="nav_item" @click="goToAbout" style="cursor: pointer;">
              <p>明晟之道
                <em></em>
              </p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_one' })">公司介绍</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_two' })">董事长寄语</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_three' })">使命愿景</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_six' })">资质荣誉</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_four' })">发展历程</a>
               
              </div>
            </div>
            <div class="nav_item" @click="goToProduct" style="cursor: pointer;">
              <p>产品与服务 <em></em></p>
              <div class="nav_submenu" @click.stop>
              
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productOne')">氨法脱硫</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productTwo')">烟道插板阀</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productThree')">轮胎裂解</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productFour')">压力容器</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productFive')">工程安装</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productSix')">运维服务</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productserve')">服务中心</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/download')">下载中心</a>
              </div>
            </div>
            <!-- <div class="nav_item">
              <p>解决方案 <em></em></p>
            </div> -->
            <div class="nav_item" @click="goToCase" style="cursor: pointer;">
              <p>明晟业绩 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/ingenieurwesen')">百日工程</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '1' } })">化工</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '2' } })">钢铁</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '3' } })">炭素</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '4' } })">焦化</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '5' } })">造纸</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '6' } })">火力发电/热电联产</a>
              </div>
            </div>
            <div class="nav_item" @click="goToNews" style="cursor: pointer;">
              <p>媒体中心 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/news', query: { page: 1, type: '1' } })">集团动态</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/news', query: { page: 1, type: '2' } })">行业动态</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/news', query: { page: 1, type: '3' } })">政策解读</a>
              </div>
            </div>
            <div class="nav_item" @click="goToSustainable" style="cursor: pointer;">
              <p>可持续发展 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/sustainable', hash: '#kcxfz_one' })">目标理念</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/sustainable', hash: '#kcxfz_two' })">关键成果</a>
              </div>
            </div>
            <div class="nav_item" @click="goToCarrer" style="cursor: pointer;">
              <p>人才发展 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/carrer', hash: '#carrer_one' })">企业文化</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/carrer', hash: '#carrer_three' })">人才价值观</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/personnel')">就业机会</a>
              </div>
            </div>
          </div>

          <div class="header-right">
            <a href="https://www.mirshinegroup.com/" target="_blank" class="icon_er">
              <img src="../assets/images/icon_1.png" alt="">
            </a>
            <div class="lines"></div>
            <a href="#" class="icon_kf">
              <img src="../assets/images/icon_2.png" alt="">
              <div class="icon_kf_tooltip">
                <span>业务咨询热线</span>
                <span>18560238118</span>
              </div>
            </a>
          </div>
        </div>

        <div class="header_menu" @click="openMenu">
            <img src="../assets/images/menu.png" alt="">
        </div>

        </div>
    </div>

    <div
      class="header headerfixed"
      :class="{ active: isHeaderFixedActive }"
    >
      <div class="content">
        <div class="logo" @click="goHome" style="cursor: pointer;">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <div class="nav">
          <div class="nav_center">
            <div class="nav_item" @click="goToAbout" style="cursor: pointer;">
              <p>明晟之道
                <em></em>
              </p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_one' })">公司介绍</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_two' })">董事长寄语</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_three' })">使命愿景</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_six' })">资质荣誉</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/about', hash: '#about_four' })">发展历程</a>
            
              </div>
            </div>
            <div class="nav_item" @click="goToProduct" style="cursor: pointer;">
              <p>产品与服务 <em></em></p>
              <div class="nav_submenu" @click.stop>

                <a href="javascript:void(0);" @click.stop="goToNavItem('/productOne')">氨法脱硫</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productTwo')">烟道插板阀</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productThree')">轮胎裂解</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productFour')">压力容器</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productFive')">工程安装</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productSix')">运维服务</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/productserve')">服务中心</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/download')">下载中心</a>
              </div>
            </div>
            <!-- <div class="nav_item">
              <p>解决方案 <em></em></p>
            </div> -->
            <div class="nav_item" @click="goToCase" style="cursor: pointer;">
              <p>明晟业绩 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/ingenieurwesen')">百日工程</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '1' } })">化工</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '2' } })">钢铁</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '3' } })">炭素</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '4' } })">焦化</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '5' } })">造纸</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/case', query: { type: '6' } })">火力发电/热电联产</a>
              </div>
            </div>
            <div class="nav_item" @click="goToNews" style="cursor: pointer;">
              <p>媒体中心 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/news', query: { page: 1, type: '1' } })">集团动态</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/news', query: { page: 1, type: '2' } })">行业动态</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/news', query: { page: 1, type: '3' } })">政策解读</a>
              </div>
            </div>
            <div class="nav_item" @click="goToSustainable" style="cursor: pointer;">
              <p>可持续发展 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/sustainable', hash: '#kcxfz_one' })">目标理念</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/sustainable', hash: '#kcxfz_two' })">关键成果</a>
              </div>
            </div>
            <div class="nav_item" @click="goToCarrer" style="cursor: pointer;">
              <p>人才发展 <em></em></p>
              <div class="nav_submenu" @click.stop>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/carrer', hash: '#carrer_one' })">企业文化</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem({ path: '/carrer', hash: '#carrer_three' })">人才价值观</a>
                <a href="javascript:void(0);" @click.stop="goToNavItem('/personnel')">就业机会</a>
              </div>
            </div>
          </div>

          <div class="header-right">
            <a href="https://www.mirshinegroup.com/" target="_blank" class="icon_er">
              <img src="../assets/images/icon_1.png" alt="">
            </a>
            <div class="lines"></div>
            <a href="#" class="icon_kf">
              <img src="../assets/images/icon_2.png" alt="">
              <div class="icon_kf_tooltip">
                <span>业务咨询热线</span>
                <span>18560238118</span>
              </div>
            </a>
          </div>
            
        </div>
        <div class="header_menu" @click="openMenu">
            <img src="../assets/images/menu.png" alt="">
        </div>
      </div>
    </div>
    <div class="header_m_right" :class="{ active: isMenuActive }">
        <div class="right_logo" @click="goHome" style="cursor: pointer;">
          <img src="../assets/images/logo.png" alt="">
        </div>
        <div class="header_close" @click="closeMenu">
            <img src="../assets/images/close.png" alt="">
        </div>

        <div class="m_header_content">
          <div class="nav_item" @click="goToAbout" style="cursor: pointer;">
              <p>明晟之道
                <em></em>
              </p>
            </div>
            <div class="nav_item" @click="goToProduct" style="cursor: pointer;">
              <p>产品与服务 <em></em></p>
            </div>
            <!-- <div class="nav_item">
              <p>解决方案 <em></em></p>
            </div> -->
            <div class="nav_item" @click="goToCase" style="cursor: pointer;">
              <p>明晟业绩<em></em></p>
            </div>
            <div class="nav_item" @click="goToNews" style="cursor: pointer;">
              <p>媒体中心 <em></em></p>
            </div>
            
            <div class="nav_item" @click="goToSustainable" style="cursor: pointer;">
              <p>可持续发展 <em></em></p>
            </div>
            <div class="nav_item" @click="goToCarrer" style="cursor: pointer;">
              <p>人才发展 <em></em></p>
            </div>
        </div>

    </div>
  </div>
  
</template>

<script>
export default {
  name: 'HeaderCom',
  data () {
    return {
      // 控制吸顶 header 的 active 状态
      isHeaderFixedActive: false,
      // 记录上一次滚动位置，用来判断滚动方向
      lastScrollTop: 0,
      // 控制移动端菜单的显示状态
      isMenuActive: false
    }
  },
  methods: {
    goToNavItem (target) {
      if (!target) return
      if (typeof target === 'string' && /^https?:\/\//i.test(target)) {
        window.open(target, '_blank')
        return
      }
      // 规范化 target
      const t = typeof target === 'string' ? { path: target } : target
      const currentPath = this.$route.path
      const currentHash = this.$route.hash || ''
      const targetPath = t.path || currentPath
      const targetHash = t.hash || ''

      // helper: 平滑滚动到锚点（预留头部高度）
      const scrollToHash = (hash) => {
        this.$nextTick(() => {
          const el = document.querySelector(hash)
          if (!el) {
            // 没找到目标元素则滚到顶部
            window.scrollTo({ top: 0, behavior: 'smooth' })
            return
          }
          const offset = 80
          const top = el.getBoundingClientRect().top + window.pageYOffset - offset
          window.scrollTo({ top, behavior: 'smooth' })
        })
      }

      // 同一路径下处理 hash 或 query 的重复点击
      if (currentPath === targetPath) {
        const hasCurrentQuery = this.$route && this.$route.query && Object.keys(this.$route.query).length > 0
        const hasCurrentHash = !!currentHash
        // 如果当前有 query 或 hash，而目标没有，应该执行跳转以清除参数/锚点
        if (!targetHash && !t.query && (hasCurrentQuery || hasCurrentHash)) {
          this.$router.push(t)
          return
        }
        // 若有 hash
        if (targetHash) {
          if (currentHash === targetHash) {
            // 相同 hash：手动滚动到锚点
            scrollToHash(targetHash)
          } else {
            // 不同 hash：正常跳转
            this.$router.push(t)
          }
          return
        }
        // 若有 query，比较是否完全一致
        if (t.query) {
          const sameQuery =
            JSON.stringify(this.$route.query || {}) === JSON.stringify(t.query || {})
          if (sameQuery) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          } else {
            this.$router.push(t)
          }
          return
        }
        // 同页无 hash/query：滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' })
        return
      }

      // 不同路径：正常跳转
      this.$router.push(t)
    },
    goHome () {
      // 如果当前已经在首页，则滚动到顶部
      if (this.$route.path === '/') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到首页
        this.$router.push('/')
      }
    },
    goToAbout () {
      // 如果当前已经在关于页面，则滚动到顶部
      if (this.$route.path === '/about') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到关于页面
        this.$router.push('/about')
      }
      // 如果是移动端菜单，跳转后关闭菜单
      if (this.isMenuActive) {
        this.closeMenu()
      }
    },
    goToProduct(){
      // 如果当前已经在关于页面，则滚动到顶部
      if (this.$route.path === '/product') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到关于页面
        this.$router.push('/product')
      }
      // 如果是移动端菜单，跳转后关闭菜单
      if (this.isMenuActive) {
        this.closeMenu()
      }
    },
    goToCase () {
      // 如果当前已经在案例页面，则滚动到顶部
      if (this.$route.path === '/case') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到案例页面
        this.$router.push('/case')
      }
      // 如果是移动端菜单，跳转后关闭菜单
      if (this.isMenuActive) {
        this.closeMenu()
      }
    },
    goToNews () {
      // 如果当前已经在新闻页面，则滚动到顶部
      if (this.$route.path === '/news') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到新闻页面
        this.$router.push('/news')
      }
      // 如果是移动端菜单，跳转后关闭菜单
      if (this.isMenuActive) {
        this.closeMenu()
      }
    },
    goToSustainable () {
      // 如果当前已经在可持续发展页面，则滚动到顶部
      if (this.$route.path === '/sustainable') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到可持续发展页面
        this.$router.push('/sustainable')
      }
      // 如果是移动端菜单，跳转后关闭菜单
      if (this.isMenuActive) {
        this.closeMenu()
      }
    },
    goToCarrer () {
      // 如果当前已经在人才发展页面，则滚动到顶部
      if (this.$route.path === '/carrer') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        // 跳转到人才发展页面
        this.$router.push('/carrer')
      }
      // 如果是移动端菜单，跳转后关闭菜单
      if (this.isMenuActive) {
        this.closeMenu()
      }
    },
    openMenu () {
      this.isMenuActive = true
    },
    closeMenu () {
      this.isMenuActive = false
    },
    handleScroll () {
      // 通过选择器获取页面上的 banner 区域
      const bannerEl = document.querySelector('.bannerhref')
      if (!bannerEl) return

      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0

      const bannerTop = bannerEl.offsetTop
      const bannerHeight = bannerEl.offsetHeight
      const bannerBottom = bannerTop + bannerHeight

      // 在 banner 区域内，强制移除 active
      if (scrollTop < bannerBottom) {
        this.isHeaderFixedActive = false
        this.lastScrollTop = scrollTop
        return
      }

      // 超过 banner，按滚动方向控制 active
      if (scrollTop < this.lastScrollTop) {
        // 向上滚动：显示 fixed header
        this.isHeaderFixedActive = true
      } else if (scrollTop > this.lastScrollTop) {
        // 向下滚动：隐藏 fixed header
        this.isHeaderFixedActive = false
      }

      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    }
  },
  mounted () {
    this.lastScrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.icon_kf {
  position: relative;
}

.icon_kf_tooltip {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 8px;
  padding: 8px 12px;
  background: #000;
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.icon_kf_tooltip::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #000;
}

.icon_kf:hover .icon_kf_tooltip {
  opacity: 1;
  visibility: visible;
}

.icon_kf_tooltip span {
  display: block;
  line-height: 1.4;
}

.icon_kf_tooltip span:first-child {
  font-size: 11px;
  opacity: 0.9;
}

.icon_kf_tooltip span:last-child {
  font-size: 14px;
  font-weight: 500;
}

.nav_item {
  position: relative;
  padding-bottom: 10px;
}

.nav_submenu {
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  min-width: 200px;
  background: rgba(0, 0, 0, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 6px 0;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.2s ease;
  z-index: 1600;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}

.nav_submenu::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -10px;
  height: 10px;
}

.nav_submenu a {
  color: #fff;
  font-size: 14px;
  line-height: 1.8;
  padding: 10px 16px;
  white-space: nowrap;
  text-decoration: none;
  display: block;
}

.nav_submenu a + a {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.nav_submenu a:hover {
  background: rgba(14, 158, 161, 0.15);
  color: #0e9ea1;
}

.nav_item:hover .nav_submenu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

@media screen and (max-width: 768px) {
  .nav_submenu {
    display: none;
  }
}
</style>
